/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect } from 'react';

const SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/144159233.js';

export const PartnerFormHubspot = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      return;
    }

    const script = document.createElement('script');

    script.src = SCRIPT_SRC;
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="hs-form-frame"
      data-region="eu1"
      data-form-id="b57bfc5a-db52-43af-bc51-5db2c00eea6b"
      data-portal-id="144159233"
    />
  );
};
